module.exports = __webpack_public_path__ + "static/media/icon-fashion-full.36070d03.png";